import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'restoreid-header',
  templateUrl: './restoreid-header.component.html',
  styleUrls: ['./restoreid-header.component.scss', ]
})
export class RestoreidHeaderComponent {

  constructor(private _router: Router) {}

  isLoginRoute(): boolean {
    return this._router.url === '/login';
  }
}
